// extracted by mini-css-extract-plugin
module.exports = {"regulations":"footer-module--regulations--3Sn_2","socialmedias":"footer-module--socialmedias--soiSH","socialmedium":"footer-module--socialmedium--2Xpcn"};